import { UtensilsCrossed } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../i18n/translations";
import { Reveal, SectionHeading, Sparkles } from "../components/ui-bits";

export default function Restaurant() {
  const { t } = useLanguage();
  return (
    <main className="pt-32 pb-10 theme-amber">
      <section className="relative max-w-7xl mx-auto px-5" data-testid="restaurant-section">
        <Sparkles count={10} />
        <SectionHeading eyebrow="Helios" title={t("restaurant.title")} sub={t("restaurant.sub")} />

        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <Reveal>
            <div>
              <p className="text-lg text-[#E2F1FF] leading-relaxed">{t("restaurant.text")}</p>
              <div className="mt-8">
                <a
                  href={IMAGES.menuPdf}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="menu-card-button"
                  className="btn-neon font-display text-base tracking-[0.2em] uppercase px-10 py-4 rounded-full inline-flex items-center gap-2"
                >
                  <UtensilsCrossed size={18} /> {t("restaurant.menu")}
                </a>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="relative rounded-3xl overflow-hidden group">
              <img src={IMAGES.desserts} alt="Restaurant Helios" className="w-full h-96 object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#05070B]/70 to-transparent" />
            </div>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mt-14">
          <Reveal>
            <div className="relative rounded-3xl overflow-hidden group h-72">
              <img src={IMAGES.food1} alt="Gerechten" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#05070B]/80 to-transparent" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="relative rounded-3xl overflow-hidden group h-72">
              <img src={IMAGES.cocktails} alt="Drankjes" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#05070B]/80 to-transparent" />
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
